import React, { Component } from "react";
import Page from "../shared/Page";
import PropTypes from "prop-types";

class TermsPage extends Component {
	componentDidMount() {
		(function(d, s, id) {
			var js,
				tjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s);
			js.id = id;
			js.src = "https://app.termly.io/embed-policy.min.js";
			tjs.parentNode.insertBefore(js, tjs);
		})(document, "script", "termly-jssdk");
	}
	render() {
		return (
			<Page title="Terms">
				<div name="termly-embed" data-id="dfe16754-7752-4d4c-82cf-7121993660bd" data-type="iframe"></div>
			</Page>
		);
	}
}
TermsPage.propTypes = {
	match: PropTypes.object,
};

export default TermsPage;
